import Vue from 'vue';

const success = (data, resolve) => {
  resolve(data);
};

const failed = (errors, reject) => {
  reject(errors);
};

export default (id, modul) => (
  new Promise((resolve, reject) => {
    Vue.$http
      .post(`/module/subscribe/${id}`, modul)
      .then((response) => {
        success(response.data, resolve);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/modules/subscribe.js